<nav class="menuDropdown-nav">
    <ng-container *ngFor="let elemento of elementos">
        <neo-menu-dropdown-elem [ngClass]="{'elementoPrincipal': principal}" *ngIf="!elemento?.visible || elemento.visible"
            [elemento]="elemento">
        </neo-menu-dropdown-elem>
    </ng-container>
</nav>
